import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migrateCommand } from '../utils/migrateCommand'
import { migrateCarousel } from './migrateCarousel'

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateCommand({
    page,
    structureType: structureTypes.CAROUSEL,
    migrateFunction: migrateCarousel,
  })
}
